define.alias("shared/components/shared/upgrade/mobile-plan-card", "calendar/components/shared/upgrade/mobile-plan-card");